export enum CustomMediaRecorderError {
  NoMediaStreamFound = 'noMediaStreamFound',
}
